export { getModalIcon } from './getModalIcon';
